import React, { 
    useContext, 
    useRef, 
    useState 
} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import MaskedInput from 'react-maskedinput';
import axios from 'axios';

import { ConfiguracaoSistemaContexto } from '../ConfiguracaoSistemaContexto';

// configura numero de envio whatsapp
export default function ConfiguraNumeroEnvioWhatsapp(){

    const telefoneInput = useRef(null);

    const { chaves } = useContext(ConfiguracaoSistemaContexto);
    const { apiWhatsapp } = chaves;

    // estados
    const [salvando, alterarSalvando] = useState(false);
    const [numeroTelefone, alterarNumeroTelefone] = useState(apiWhatsapp?.numero ? apiWhatsapp.numero.substring(2) : '');
    
    // salva valor novo
    async function salvar(){
        // salvando
        alterarSalvando(true);

        try {

            // salvar objeto api telefone
            const dadosSalvar = {
                ...apiWhatsapp,
                numero: '55' + numeroTelefone 
            };

            const { data } = await axios.put(`/configuracaoSistema/apiWhatsapp`, {
                valor: JSON.stringify(dadosSalvar)
            });

            if(data) {
                // mensagem de sucesso
                toast(({ closeToast }) => <>
                    <div className="toast-header">
                        <strong className="mr-auto">Número salvo com sucesso!</strong>
                        <button
                            onClick={closeToast}
                            className="ml-2 mb-1 close btn-outline-light outline-0"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>                    
                </>, { autoClose: 3000 });
            }

        } catch({ response }) {
            console.error(response);
        } finally {
            alterarSalvando(false);
        }
    }

    return (
        <div className="d-flex align-items-start justify-content-center position-relative">
            <div className="flex-grow-1 p-1">
                Número remetente para envios automatizados via Whatsapp
            </div>
            <MaskedInput
                className={"form-control form-control-sm"}
                mask={"(11) 11111-1111"}
                ref={telefoneInput}
                value={numeroTelefone || ''}
                onChange={() => {
                    let telefone = telefoneInput.current.mask.getRawValue().split('_').join('');
                    if(telefone === "") telefone = null;
                    alterarNumeroTelefone(telefone);
                }}
                onPasteCapture={async (e) => {

                    e.preventDefault();

                    // resgata texto que está colado
                    let textoColado = await navigator.clipboard.readText();

                    if(typeof textoColado !== "string") return;

                    // remove caracteres especiais e deixa somente numeros
                    textoColado = textoColado.replace(/\s+/g, '').replace(/\D/g, '');

                    // monta mascara
                    const mascara = '11111111111';
                    
                    // prepara valor formatado
                    let novoValor = '';
                    let j = 0;

                    // percorre se baseando pela mascara
                    for (let i = 0; i < mascara.length; i++) {

                        // resgata valor atual
                        const valor = textoColado[j++];
                        
                        // verifica se é numero e insere a variavel
                        if(!isNaN(valor)) novoValor += valor;
                        
                    }

                    // altera dados do telefone
                    const telefone = novoValor.split('_').join('').replace(/\s+/g, '');
                    alterarNumeroTelefone(telefone);
                }}
                style={{
                    width: 300,
                    height: 36
                }}
            />
            <div style={{ marginRight: -14, marginLeft: 6 }}>
                <Button
                    variant='success'
                    onClick={salvar}
                    style={{ height: 36, minWidth: 72 }}
                >
                    {salvando ? 
                        <>
                            <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                        </> : 
                        <span>Salvar</span>
                    }
                    
                </Button>
            </div>
        </div>
    )

}